module.exports = __webpack_public_path__ + "static/media/smiley-movement.ba3293f8.png";